import React from 'react';

interface ButtonTypes {
  title: string;
  handleClick:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  className?: string | undefined;
  type?: 'button' | 'submit';
  disable?: boolean;
}

const Button = ({
  title,
  handleClick,
  className = '',
  type = 'button',
  disable = false,
}: ButtonTypes) => {
  return (
    <button
      className={`btn ${className}`}
      type={type}
      onClick={handleClick}
      disabled={disable}
    >
      {title}
    </button>
  );
};

export default Button;
